export class ActionType {
  static PACKAGING_LABEL  = 'packaging_label';
  static INVOICE  = 'invoice';
  static REORDER = 're_order';
  static CONFIRMATION = 'confirmation';
  static TEXT = 'text';
  static EMAIL = 'email';
  static FORM = 'form';


  public id: number;
  public name: string;
  public label?: string;
  public translationKey: string;
  public hasNextStepField: boolean;
}
